'use strict';

const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

exports.isEasingArray = isEasingArray;
//# sourceMappingURL=is-easing-array.cjs.map
